import {
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
  Stack,
  IconButton,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteSiteDialog from "./DeleteSiteDialog";
import "./sitePage.scss";
import { AppState, useAppDispatch, useAppSelector } from "../../store";
import {
  setIsEditSite,
  setOpenAddSiteModal,
  setOpenDeleteSite,
} from "../../store/slices/studiesSlice";
import { codelistUtils } from "../../utils/codelistUtils";

const SiteDetails: React.FunctionComponent<any> = (props) => {
  const {
    getAllSitesFunc,
    setOpenSiteDetails,
    paginationModel,
    filterVal,
    codelistData,
  } = props;
  const dispatch = useAppDispatch();
  const siteData = useAppSelector(
    (state: AppState) => state.studiesSlice.siteDetails
  );
  const openDelete = useAppSelector(
    (state: AppState) => state.studiesSlice.openDeleteSite
  );

  const onEditClick = async (data: any) => {
    dispatch(setOpenAddSiteModal(true));
    dispatch(setIsEditSite(true));
  };
  const onDeleteClick = (data: any) => {
    dispatch(setOpenDeleteSite(true));
  };

  return (
    <>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="primary" onClick={() => setOpenSiteDetails(false)}>
            Sites
          </Link>
          <Typography color="text.primary">{siteData?.site_id}</Typography>
        </Breadcrumbs>
      </div>
      <Box mt={2}>
        <Card className="pageContent" key={siteData?.id}>
          <CardContent>
            <Grid container spacing={3} mb={2.5}>
              <Grid item className="maxWidthMinusActionBtns">
                <Typography variant="h6" component="div" className="wordWrap">
                  <Stack direction="row" columnGap={1}>
                    <Box className="wordBreakAll">{siteData?.name} &nbsp;</Box>
                    <Chip
                      label={
                        codelistData?.length > 0 &&
                        codelistUtils(
                          codelistData,
                          siteData.site_status_code,
                          siteData?.site_status_value_code
                        )?.selectedValue
                      }
                      variant="outlined"
                      color="info"
                      aria-label="Site Status"
                    />
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {siteData?.site_id}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item>
                <Stack
                  direction="row"
                  spacing={1}
                  className="justifyContentCenter alignItemsCenter"
                >
                  <IconButton
                    color="primary"
                    size="small"
                    title="Edit Site"
                    onClick={() => onEditClick(siteData)}
                    aria-label="Click to edit Site details"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    color="primary"
                    size="small"
                    title="Delete Site"
                    onClick={() => onDeleteClick(siteData)}
                    aria-label="Click to delete Site"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={1.5}>
              <Grid item sm={12} md={12}>
                <Typography variant="caption" display="block">
                  Address
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {siteData?.street_address} ,
                  {siteData?.unit_number && `${siteData?.unit_number},`}{" "}
                  {siteData?.city}, {siteData?.state}, {siteData?.postal_code},{" "}
                  {codelistData?.length > 0 &&
                    codelistUtils(
                      codelistData,
                      siteData.country_code,
                      siteData?.country_value_code
                    )?.selectedValue}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={2}>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Name</Typography>
                <Typography variant="body1" className="wordWrap">
                  {siteData?.contact_name}
                </Typography>
              </Grid>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Email</Typography>
                <Typography variant="body1" className="wordWrap">
                  {siteData?.contact_email}
                </Typography>
              </Grid>
              <Grid item sm={12} md={4}>
                <Typography variant="caption">Contact Phone Number</Typography>
                <Typography variant="body1">
                  {siteData?.contact_phone_number}
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item sm={12} md={6}>
                <Typography variant="caption" display="block">
                  Principal Investigator
                </Typography>
                <Typography variant="body1" gutterBottom>
                  {siteData?.principal_investigator}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>

      {openDelete && (
        <DeleteSiteDialog
          getAllSitesFunc={getAllSitesFunc}
          paginationModel={paginationModel}
          filterVal={filterVal}
          setOpenSiteDetails={setOpenSiteDetails}
        />
      )}
    </>
  );
};

export default SiteDetails;
